import React, { useState } from 'react';
import { Grid, Typography, Breadcrumbs } from '@mui/material';
import { Link } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import {Waypoint} from 'react-waypoint'
import Testimonial from '../testimonial';
import FootPrint from '../../footprint';
// import ProjectSlick from '../projects';

const AcService = () => {

    const [numberBool, setNumberBool] = useState(false);

    const slides = [
        <Grid item xs={12} sx={{width:'90% !important'}}>
            <img src='/assets/images/services_image/electrical/stt-e.png' alt='aiims1' style={{marginBottom:'2em'}} />
            <Typography variant='body2' className='slider-title-text' component={'h3'} sx={{mb:'0.25em'}}>STT, Mumbai</Typography>
            <Typography variant='body2' className='normal-text' component={'p'} sx={{mt:0, mb:'0.5em'}}>Navi Mumbai, Maharashtra</Typography>
        </Grid>,
        <Grid item xs={12} sx={{width:'90% !important'}}>
            <img src='/assets/images/services_image/electrical/atc-e.png' alt='aiims1' style={{marginBottom:'2em'}} />
            <Typography variant='body2' className='slider-title-text' component={'h3'} sx={{mb:'0.25em'}}>ATC Tower, Kolkata Airport</Typography>
            <Typography variant='body2' className='normal-text' component={'p'} sx={{mt:0, mb:'0.5em'}}>Kolkata, West Bengal</Typography>
        </Grid>,
        <Grid item xs={12} sx={{width:'90% !important'}}>
            <img src='/assets/images/services_image/electrical/goa-e.png' alt='Goa Airport' style={{marginBottom:'2em'}} />
            <Typography variant='body2' className='slider-title-text' component={'h3'} sx={{mb:'0.25em'}}>MOPA International Airport</Typography>
            <Typography variant='body2' className='normal-text' component={'p'} sx={{mt:0, mb:'0.5em'}}>Goa</Typography>
        </Grid>,
        <Grid item xs={12} sx={{width:'90% !important'}}>
            <img src='/assets/images/services_image/electrical/bhita-e.png' alt='aiims1' style={{marginBottom:'2em'}} />
            <Typography variant='body2' className='slider-title-text' component={'h3'} sx={{mb:'0.25em'}}>ESIC Medical College & Hospital, Bihta</Typography>
            <Typography variant='body2' className='normal-text' component={'p'} sx={{mt:0, mb:'0.5em'}}>Patna, Bihar</Typography>
        </Grid>,
        <Grid item xs={12} sx={{width:'90% !important'}}>
            <img src='/assets/images/services_image/electrical/sky-e.png' alt='aiims1' style={{marginBottom:'2em'}} />
            <Typography variant='body2' className='slider-title-text' component={'h3'} sx={{mb:'0.25em'}}>Sky Mansion, New Delhi</Typography>
            <Typography variant='body2' className='normal-text' component={'p'} sx={{mt:0, mb:'0.5em'}}>Chattarpur, New Delhi</Typography>
        </Grid>
        
    ]
    
return (
    <Grid item xs={12} sx={{width:'100%'}}>
        <Grid item xs={12} sx={{display: 'flex', flexFlow: 'column', alignItems:'center'}}>
            <Grid item className='title-div'
                // sx={{px:10, width:'100%', maxWidth:1440, display:'flex', justifyContent:'center', pt:'2em'}}
            >
                <Grid item sx={{px:!isMobile && 12.5, background: !isMobile && 'url(/assets/images/hvacbg.png) no-repeat', backgroundPosition:'bottom right'}}>
                    <Breadcrumbs aria-label="breadcrumb">
                        <Link to={'/'} className='normal-text title-color' style={{textDecoration:'none'}} >Home</Link>
                        <Link to={'/services'} className='normal-text title-color' style={{textDecoration:'none'}} >Services</Link>
                        <Typography variant='body2' component={'p'} sx={{color:'#535353'}}>AC Installation</Typography>
                    </Breadcrumbs>
                    <Grid item xs={12} sx={{pt:'26px',pb:'8em'}}>
                        <Typography variant='body2' component={'h1'} className='titleStyle title-color nwhead' sx={{ pb:2 }}></Typography>
                        


                        <div className='cussec'>

                       <section class="mep-content">
                        
<h1><b>Air Conditioning Contractor in India: Providing Tailored HVAC Solutions for Every Need</b></h1>

<p>Air systems shape how people work, recover, and stay alert across long operational hours. Poor cooling decisions create hidden costs, discomfort, and constant repair cycles. At <a href="https://www.uniqueengineersltd.com/"><b>Unique Engineers</b></a>, we approach air systems as long term infrastructure, not short term equipment. Every project begins with listening, not assumptions. Clients value this approach because it protects performance, budgets, and people over decades, not seasons.</p>

<h2><b>Why Choose Unique Engineers for Your Air Conditioning Needs?</b></h2>

<p>Clients approach us when they want steady outcomes, not short term fixes. We look at air systems as part of everyday working life, not isolated installations.</p>

<p>Our teams study how cooling affects productivity, maintenance cycles, and long term operating costs. This wider view helps systems perform reliably while staying economical over time.</p>

<p>Years of on ground experience across industries shape every decision we make. That experience shows in planning, coordination, and after handover support.</p>

<b>What Makes Our Work Distinct</b>
<ul>
  <li><b>Proven Experience And Technical Depth:</b> We bring years of hands-on project exposure across commercial and industrial environments.</li>
  <li><b>Solutions Built Around Real Use:</b> Every air conditioning system reflects the space, load patterns, and future needs of the facility.</li>
  <li><b>End To End Responsibility:</b> We manage installation, upkeep, and corrective work without shifting accountability.</li>
  <li><b>Focus On Energy Responsibility:</b> Our systems balance comfort with controlled energy use and stable long term performance.</li>
  <li><b>Client First Working Style:</b> We communicate clearly, respond promptly, and remain involved through every project stage.</li>
</ul>

<h2><b>Engineering-Led Approach To Commercial And Industrial Cooling</b></h2>

<p>Every facility carries a different thermal load, operational rhythm, and risk profile. This section explains how design thinking guides each engagement with precision. Our team studies occupancy patterns, heat generation sources, and airflow paths before selecting equipment. This method prevents oversized systems that waste energy and undersized systems that strain components.</p>

<p>We focus on system harmony rather than isolated machines. Ducting, controls, insulation, and placement receive equal attention during planning stages. Compliance with Indian standards and international best practices remains integral. This protects facilities during audits, expansions, and future technology upgrades.</p>

<h2><b>End-To-End Execution With Accountable Delivery</b></h2>

<p>Air systems fail when responsibility fragments across vendors and contractors. A single accountable framework avoids this breakdown.</p>

<p>Unique Engineers manages design coordination, procurement, installation, testing, and commissioning under one roof. Clients benefit from reduced handovers and faster issue resolution.</p>

<p>Project schedules receive the same discipline as engineering drawings. Each milestone undergoes internal checks before progressing. This integrated model positions us alongside leading <a href="https://www.uniqueengineersltd.com/services/hvac-company-in-india/"><b>HVAC Company in India</b></a> discussions, without chasing labels or rankings.</p>

<h2><b>Solutions Designed For Industrial Scale And Reliability</b></h2>

<p>Industrial environments demand resilience, safety, and consistent output across extreme conditions. This section outlines how solutions adapt to those realities.</p>

<p>After careful evaluation, we deploy systems suitable for factories, data centres, pharmaceutical plants, and large commercial facilities. Load diversity and redundancy planning receive priority.</p>

<p>We collaborate closely with process engineers to avoid interference with production workflows. This coordination reduces downtime during installation and maintenance phases.</p>

<p>Many clients compare options among top HVAC companies in India before choosing partners. They value our clarity, documentation, and steady execution.</p>

<h3><b>Integrated Services Across MEP And Safety Systems</b></h3>

<p>Cooling systems rarely operate in isolation within modern facilities. This section explains the advantage of coordinated infrastructure planning. We align air systems with electrical layouts, plumbing routes, and control networks during early design stages. This reduces clashes and future rework.</p>

<p>Our coordination experience supports complex facilities managed by a single <a href="https://www.uniqueengineersltd.com/"><b>MEP Contractor in India</b></a>, ensuring smoother approvals and site execution.</p>

<p>Fire safety integration also receives structured attention. Coordination with <a href="https://www.uniqueengineersltd.com/services/industrial-fire-fighting-contractors-in-india/"><b>Industrial fire fighting contractors in India</b></a> ensures compliance without compromising airflow or access routes.</p>

<h3><b>What Clients Experience During And After Handover</b></h3>

<p>This section explains outcomes clients notice beyond installation completion, focusing on operational life. Clients receive detailed documentation, training sessions, and performance benchmarks at handover. These resources support internal teams during daily operation.</p>

<p>Preventive maintenance frameworks extend equipment life and reduce emergency callouts. This approach stabilises operational expenditure. Facilities supported by <a href="https://www.uniqueengineersltd.com/services/industrial-electrical-contractors-in-india/"><b>industrial electrical contractors in India</b></a> benefit from aligned load management and control strategies.</p>

<p>As an experienced <a href="https://www.uniqueengineersltd.com/services/mepf-contractor-in-india/"><b>MEPF Contractor in India</b></a>, we remain available for system optimisation, expansions, and audits long after commissioning.</p>

<h3><b>Our Approach to HVAC Projects</b></h3>

<p>We treat every HVAC project as a long term responsibility, not a one time assignment. Our teams work carefully, asking the right questions before suggesting any technical direction.</p>

<ul>
  <li><b>Understanding Your Space and Priorities:</b> We begin by listening. Our engineers study how the space is used, how people move within it, and what performance you expect daily. This step helps align system choices with real needs and realistic budgets.</li>
  <li><b>Thoughtful System Design and Planning:</b> Our designs balance cooling performance with energy responsibility. We plan layouts, controls, and capacities that support comfort without creating unnecessary operational strain.</li>
  <li><b>Disciplined and Careful Installation:</b> Installation follows a structured process. Skilled teams use proven methods and reliable equipment to ensure systems operate smoothly from the first day.</li>
  <li><b>Ongoing Care and System Evolution:</b> Our involvement continues after handover. Regular maintenance, performance reviews, and upgrade planning keep systems reliable as usage patterns change over time.</li>
</ul>

<h3><b>Why Organisations Trust Unique Engineers</b></h3>

<p>Our teams respect operational realities, safety protocols, and site constraints. This respect builds confidence across stakeholder groups.</p>

<p>Facilities seeking an HVAC contractor in India often discover that trust forms through consistency, not promises.</p>


                       </section>
                        </div>

                    </Grid>
                </Grid>
            </Grid>
            <Grid item sx={{backgroundColor:'#F4F8FA', mt:'-3em', position:'relative', zIndex:1, px: !isMobile ? 10 : 2.5, width:'100%', display:'flex', justifyContent:'center'}}>
                <Grid item sx={{width:'100%', px:!isMobile ? 10 : 0, pt: !isMobile ? '5em' : '3em', pb: !isMobile ? '5em' : '3em'  }}>
                    <Grid item sx={{}}>
                        <Typography className='titleStyle title-color' sx={{ pb:'1em', textAlign: 'center'}}>Safety served with comfort</Typography>
                        <Grid item sx={{width:'100%', display:'flex', pb: !isMobile && '2em' }}>
                            <Grid item xs={4} sx={{}}>
                                <Typography className='titleStyle title-color' sx={{ pb:0, fontFamily:'Inter !important', fontWeight:'700 !important', textAlign:'center'}}>
                                    { numberBool &&  <p class="numbers">
                                        <span class="numbers__window">
                                            <span class="numbers__window__digit numbers__window__digit--1" data-fake="4642210061">4</span>
                                        </span>
                                    </p>
                                    }
                                </Typography>
                                <Typography className='normal-text' sx={{pb:2, textAlign:'center'}}>Stadiums <br/> made spacious</Typography>
                            </Grid>
                            <Grid item xs={4} sx={{}}>
                                <Waypoint onEnter={() => setNumberBool(true)} />
                                <Typography className='titleStyle title-color' sx={{ pb:0, fontFamily:'Inter !important', fontWeight:'700 !important', textAlign:'center'}}>
                                    { numberBool &&  <p class="numbers">
                                        <span class="numbers__window">
                                            <span class="numbers__window__digit numbers__window__digit--1" data-fake="6642212862">6</span>
                                        </span>
                                        <span class="numbers__window">
                                            <span class="numbers__window__digit numbers__window__digit--2" data-fake="8641218062">8</span>
                                        </span>
                                    </p>
                                    }
                                </Typography>
                                <Typography className='normal-text' sx={{pb:2, textAlign:'center'}}>Stress-free and <br/> comfortable hospitals </Typography>
                            </Grid>
                            <Grid item xs={4} sx={{}}>
                                <Typography className='titleStyle title-color' sx={{ pb:0, fontFamily:'Inter !important', fontWeight:'700 !important', textAlign:'center'}}>
                                    { numberBool &&  <p class="numbers">
                                        <span class="numbers__window">
                                            <span class="numbers__window__digit numbers__window__digit--1" data-fake="5612210038">5</span>
                                        </span>
                                        <span class="numbers__window">
                                            <span class="numbers__window__digit numbers__window__digit--2" data-fake="8824918502">8</span>
                                        </span>
                                    </p>
                                    }
                                </Typography>
                                <Typography className='normal-text' sx={{pb:2, textAlign:'center'}}>Industries <br/> innovated for</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <FootPrint title='Our projects' imageArray = {slides} content='We offer unique solutions for every project we undertake and our experts examine the details minutely. We also take pride in providing sustainable solutions that minimize our carbon footprint or impact on environment.' />
            <Testimonial title={'Words of satisfaction'}  />

            <> 
            <Grid item  className='title-div'
            // sx={{px:!isMobile ? 10 : 0, width:'100%', maxWidth:1440, display:'flex', justifyContent:'center', pt:'2em'}}
            >
            <Grid item sx={{px: !isMobile && 12.5}}>
            <Grid item xs={12} sx={{pt:'2em', pb: !isMobile ? '8em' : '6em'}}>
            <div container style={{width:'100%', justifyContent:'center', margin:'0px 0px 0px'}}>
            <div class="cussec cusmargnsec2"> 
 
            <h4><b>Frequently Asked Questions</b></h4>

<details open className='cusfq'>
  <summary>What types of projects do you handle as an air conditioning contractor in India?</summary>
  <p>We handle commercial buildings, industrial plants, healthcare facilities, data centres, and institutional campuses across diverse climatic zones.</p>
</details>

<details className='cusfq'>
  <summary>How early should air system planning begin within a project lifecycle?</summary>
  <p>Planning should begin during concept design stages. Early involvement reduces redesign costs and coordination conflicts later.</p>
</details>

<details className='cusfq'>
  <summary>Do you work alongside other service contractors on large sites?</summary>
  <p>Yes. We regularly coordinate with plumbing, electrical, automation, and safety teams to maintain system compatibility.</p>
</details>

<details className='cusfq'>
  <summary>How do you ensure energy efficiency without sacrificing performance?</summary>
  <p>We balance load calculations, control strategies, and equipment selection to achieve stable efficiency across real operating conditions.</p>
</details>

<details className='cusfq'>
  <summary>What support do clients receive after system commissioning?</summary>
  <p>Clients receive documentation, training, maintenance planning support, and technical assistance during audits or future upgrades.</p>
</details>


            </div>
            </div>   
            </Grid></Grid></Grid>
            </>

        </Grid>
    </Grid>
)

}

export default AcService;